<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>鸣野VIP</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-width="60px"
        label-position="right"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item
          label="来源"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-select
            v-model="query.origin"
            filterable
            clearable
            @change="selList()"
          >
            <el-option
              v-for="item in sourselist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;">
          <DeptRoleTeacherSelect v-model="query.adviserID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" @change="adviserClick()" />
        </el-form-item>
        <el-form-item label="营销" label-width="80px">
          <DeptRoleTeacherSelect v-model="query.marketID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" @change="datelClick()" />
        </el-form-item>
        <el-form-item label="学历" label-width="60px">
          <el-select v-model="query.eduBack" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地" label-width="70px">
          <el-select v-model="query.province" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in provinceList" :label="item.areaName" :value="item.areaName" :key="item.areaID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生/家长" label-width="80px">
          <el-select v-model="query.studentType" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赴日时间" label-width="80px">
          <el-select v-model="query.abroadPlan" filterable clearable placeholder="请选择" @change="selList()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in planList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缴费时间" label-width="80px">
          <el-date-picker
            v-model="query.daterange"
            @change="datelClick()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="exportClick()">导出</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>鸣野VIP学生</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text" @click="goToStageList">升学列表</el-button> -->
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="enrolType" label="类型" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.isRenewal ? 'warning' : 'success'">{{ scope.row.enrolType || '新报' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="inputTime" label="添加时间" width="110"></el-table-column>
          <el-table-column prop="paymentDate" label="缴费时间" width="110"></el-table-column>
          <el-table-column prop="paymentAmount" label="缴费金额" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.paymentAmount">¥{{ scope.row.paymentAmount }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="真实姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="abroadDate" label="赴日时间" width="100"></el-table-column>
          <el-table-column prop="applySchoolStu" label="申请学校" :width="150"></el-table-column>
          <!-- <el-table-column prop="languageSchool" label="申请学校" :width="150"></el-table-column> -->
          <!--  -->
          <el-table-column prop="japanese" label="日语" :width="150"></el-table-column>
          <el-table-column prop="english" label="英语" :width="150"></el-table-column>
          <el-table-column prop="major" label="专业" :width="150"></el-table-column>
          <el-table-column prop="artsScience" label="文理" :width="150"></el-table-column>
          <!--  -->
          <el-table-column prop="origin" label="来源"></el-table-column>
          <el-table-column prop="location" label="地区" :width="150"></el-table-column>
          <el-table-column prop="courseName" label="学习课程" :width="150"></el-table-column>
          <el-table-column prop="startTime" label="开课时间" :width="120"></el-table-column>
          <el-table-column prop="endTime" label="结课时间" :width="120"></el-table-column>
          <el-table-column prop="myAdviserName" label="顾问"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-mingye="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="isMarketingOnlyMingye(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid=scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="申请案例" placement="top">
                  <el-button type="danger" size="mini" icon="el-icon-notebook-1" @click="editClickFeel(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid=scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="升学操作" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button type="warning" size="mini" icon="el-icon-s-flag"
                    @click="stageClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="老学员续费" placement="top" v-if="canEditMingye(scope.row) && (userIsAdmain||userIsAdviser)">
                  <el-button type="info" size="mini" icon="el-icon-refresh"
                    @click="renewClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit"
                    @click="editStudentClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="课程管理" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button type="success" size="mini" icon="el-icon-s-order"
                    @click="openCourseClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="申请案例" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button type="danger" size="mini" icon="el-icon-notebook-1" @click="editClickFeel(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :size-page="pageSize"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 编辑学生基础信息对话框 -->
    <!-- 编辑学生信息（与鸣野资源列表一致，完整字段） -->
    <el-dialog title="编辑学生信息" :visible.sync="studentDialogVisible" width="900px">
      <el-form :model="studentForm" ref="studentForm" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitStudentForm('studentForm')">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="添加时间" prop="myInputTime" :rules="[{required:true,message:'不能为空'}]">
              <el-date-picker v-model="studentForm.myInputTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择时间" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="营销老师" prop="myMarketID">
              <el-select v-model="studentForm.myMarketID" placeholder="请选择营销老师" filterable clearable style="width: 100%">
                <el-option v-for="item in marketlist" :label="item.realName" :value="item.userID" :key="item.userID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="姓名" prop="realName" :rules="[{required:true,message:'请输入姓名'}]">
              <el-input v-model="studentForm.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="sex" :rules="[{required:true,message:'请选择性别'}]">
              <el-radio-group v-model="studentForm.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="资源状态" prop="myStatus" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="studentForm.myStatus" clearable placeholder="请选择资源状态" filterable style="width: 100%">
                <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学历" prop="eduBack">
              <el-select v-model="studentForm.eduBack" clearable placeholder="请选择学历" filterable style="width: 100%">
                <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="地区">
              <el-cascader :options="areaList" :props="{ label: 'label', value: 'label' }" v-model="selectedOptions"
                style="width: 100%" clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="wechat" label="微信">
              <el-input v-model="studentForm.wechat" placeholder="请输入微信"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="qq" label="QQ">
              <el-input v-model="studentForm.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="来源" prop="origin">
              <el-select v-model="studentForm.origin" clearable placeholder="请选择来源" filterable style="width: 100%">
                <el-option v-for="item in sourselist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="日语" prop="japanese">
              <el-select v-model="studentForm.japanese" placeholder="请选择日语水平" filterable clearable style="width: 100%">
                <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="推荐人" prop="recName" v-if="studentForm.origin == '留学组推荐' || studentForm.origin == '日语组推荐'">
          <el-select v-model="studentForm.recName" placeholder="请选择" filterable clearable style="width: 100%">
            <el-option v-for="item in adviserlist" :label="item.realName" :value="item.realName" :key="item.userID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input v-model.number="studentForm.mobile" type="number" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="意向课程" prop="intendedCourse">
              <el-input v-model="studentForm.intendedCourse" placeholder="请输入意向课程"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学生/家长" prop="studentType">
              <el-select v-model="studentForm.studentType" placeholder="请选择" clearable style="width: 100%">
                <el-option label="学生" value="学生"></el-option>
                <el-option label="家长" value="家长"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="跟进情况" prop="followSummary">
          <el-input v-model="studentForm.followSummary" placeholder="请输入跟进情况"></el-input>
        </el-form-item>
        <div>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="顾问老师" prop="myAdviserID">
                <DeptRoleTeacherSelect v-model="studentForm.myAdviserID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 鸣野专有字段 -->
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="英语" prop="english">
              <el-input v-model="studentForm.english" placeholder="请输入英语水平"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="文理" prop="artsScience">
              <el-select v-model="studentForm.artsScience" placeholder="请选择" clearable style="width: 100%">
                <el-option label="文科" value="文科"></el-option>
                <el-option label="理科" value="理科"></el-option>
                <el-option label="艺术" value="艺术"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="专业" prop="major">
              <el-input v-model="studentForm.major" placeholder="请输入专业"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <SelectAbroad ref="selectAbroadEdit" v-on:selabroad="function(str){ studentForm.abroadDate = str; }"></SelectAbroad>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="缴费时间" prop="paymentDate">
              <el-date-picker v-model="studentForm.paymentDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择日期" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="缴费金额" prop="paymentAmount">
              <el-input type="number" v-model.number="studentForm.paymentAmount" placeholder="请输入金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="10">
            <el-form-item label="申请学校" prop="languageSchool">
              <el-select v-model="studentForm.languageSchool" filterable clearable placeholder="请选择申请学校" style="width:100%">
                <el-option v-for="item in schoollist" :label="item.label" :value="item.label" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="学习课程" prop="courseName">
              <el-input v-model="studentForm.courseName" placeholder="请输入学习课程"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="开课时间" prop="startTime">
              <el-date-picker v-model="studentForm.startTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择日期" clearable style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="结课时间" prop="endTime">
              <el-date-picker v-model="studentForm.endTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择日期" clearable style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="出身校" prop="schoolName">
              <el-input v-model="studentForm.schoolName" placeholder="请输入出身校"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="studentDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 2026-01升级：升学操作对话框（赴日前和升学时同时显示） -->
    <el-dialog title="升学操作" :visible.sync="stageDialogVisible" width="900px">
      <el-form :model="stageForm" ref="stageForm" label-width="120px">
        <!-- 赴日前信息 -->
        <el-divider content-position="left">赴日前信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="学历">
              <el-select v-model="stageForm.eduBack" placeholder="请选择学历" filterable style="width: 100%;">
                <el-option
                  v-for="item in edubacklist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="出身校">
              <el-input v-model="stageForm.schoolName" placeholder="请输入出身校"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="日语">
              <el-input v-model="stageForm.japanese" placeholder="请输入赴日前日语水平"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="英语">
              <el-input v-model="stageForm.english" placeholder="请输入赴日前英语水平"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 升学时信息 -->
        <el-divider content-position="left">升学时信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="留考成绩">
              <el-input v-model="stageForm.examScore" placeholder="请输入留考成绩"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="专业">
              <el-input v-model="stageForm.major" placeholder="请输入专业"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="文理">
              <el-select v-model="stageForm.artsScience" placeholder="请选择" style="width: 100%;">
                <el-option label="文科" value="文科"></el-option>
                <el-option label="理科" value="理科"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="日语">
              <el-input v-model="stageForm.japaneseEnroll" placeholder="请输入升学时日语水平"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="英语">
              <el-input v-model="stageForm.englishEnroll" placeholder="请输入升学时英语水平"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="合格时间">
              <el-date-picker
                v-model="stageForm.qualifiedTime"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择合格时间"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="合格学校及专业">
          <el-input
            type="textarea"
            :rows="3"
            v-model="stageForm.qualifiedSchools"
            placeholder="请输入合格学校及专业，多个学校请用逗号分隔"
          ></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="入学学校">
              <el-input v-model="stageForm.enrolledSchool" placeholder="请输入入学学校"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="入学专业">
              <el-input v-model="stageForm.enrolledMajor" placeholder="请输入入学专业"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item>
          <el-button type="primary" :loading="submiting" @click="submitStage">提交</el-button>
          <el-button @click="stageDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 操作对话框 -->
    <el-dialog :title="'申请案例'" :visible.sync="dialogVisiblefeel"  @opened="dialogOpended()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
       
         
        <el-form-item label="申请感受" prop="feel">
          <el-input v-model="form.feel" placeholder="请输入申请感受"></el-input>
        </el-form-item>
        <el-form-item label="合格通知书">
                <div id="uploadBtn1" class="uploader uploader-warning"></div>
                <div style="padding: 0px 10px">
                  
                  <div class="uploader-text">
                    <a v-if="form.book" 
                  :href="domain + form.book" 
                  target="_blank" 
                  style="color: #409eff; text-decoration: none;">
                    {{ form.book }}
                  </a>
                  </div>
                
                  
                </div>
              </el-form-item>
              <el-form-item
          label="合格通知书图片"
          :rules="[{ required: false, message: '不能为空' }]"
        >
          <div id="uploadBtnConfig" class="uploader uploader-warning"></div>
          <img
            id="relativeName"
            :src="domain + form.bookPhoto"
            style="height: 40px; position: relative; left: 10px; top: 20px"
            v-if="form.bookPhoto"
          />
          <span
            class="imgtext"
            title
            type="info"
            style="position: relative; left: 0px; top: 1px"
          ></span>
        </el-form-item>
        <el-form-item label="聊天截图" prop="pictures">
          <div id="uploadBtn" class="uploader uploader-warning"></div>

          <el-row :gutter="24">
            <el-col :span="12" v-for="(item, index) in imgList" :key="index">
              <el-card style="margin-top: 10px;text-align: center;">
                <img
                  :src="domain + item"
                  class="image"
                  style="max-height: 100px"
                />
                <div style="padding: 0px">
                  <div class="bottom clearfix">
                    <el-button-group>
                      <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteImg(index)"
                      ></el-button>
                    </el-button-group>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-form-item>
        <div style="height: 10px"></div>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisiblefeel = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分配弹框（鸣野 VIP：可分配留学、日语） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserlist"
      :market-list="marketlist"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="true"
      :show-mingye="false"
      empty-message="请选择分配给留学或日语"
      @success="getList"
    />
    <!-- 2026-01升级：老学员续费对话框（与日语VIP续费弹窗一致） -->
    <el-dialog title="老学员续费" :visible.sync="renewDialogVisible" width="800px">
      <el-form :model="renewForm" ref="renewFormRef" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitRenew">
        <el-form-item prop="courseName" label="购买课程" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="renewForm.courseName" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item prop="paymentDate" label="缴费时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="renewForm.paymentDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="coursePrice" label="全额费用">
          <el-input-number v-model="renewForm.coursePrice" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item prop="amount1" label="一期">
              <el-input-number v-model="renewForm.amount1" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase1Date" label="一期日期">
              <el-date-picker v-model="renewForm.phase1Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount2" label="二期">
              <el-input-number v-model="renewForm.amount2" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase2Date" label="二期日期">
              <el-date-picker v-model="renewForm.phase2Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount3" label="三期">
              <el-input-number v-model="renewForm.amount3" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase3Date" label="三期日期">
              <el-date-picker v-model="renewForm.phase3Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="percentage" label="顾问提成" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="renewForm.percentage" placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item prop="classHour" label="课时数" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="renewForm.classHour" placeholder="请输入课时"></el-input>
        </el-form-item>
        <el-form-item label="上课形式">
          <el-select v-model="renewForm.classForm" placeholder="请选择上课形式" style="width: 100%;">
            <el-option label="线下课" value="线下课"></el-option>
            <el-option label="网课" value="网课"></el-option>
            <el-option label="录播课" value="录播课"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startTime" label="开始时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="renewForm.startTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择开始时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" label="结束时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="renewForm.endTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择结束时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="renewSubmiting" native-type="submit">提交</el-button>
          <el-button @click="renewDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <MingYE :stuid="showstuid" v-on:setzero="showstuid=0"></MingYE>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import MingYE from "@/components/mingye";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import SelectAbroad from "@/components/SelectAbroad";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
export default {
  data() {
    return {
      domain: url.getDomain(),
      userIsAdmain: user.isAdmin(),
      userIsAdviser: user.isAdviser(),
      userIsMarket: user.isMarket(),
      query: {},
      form: {},
      stageForm: {},
      submiting: false,
      loading: false,
      dialogVisible: false, // 课程管理对话框
      studentDialogVisible: false, // 编辑学生信息对话框
      studentForm: {}, // 编辑学生信息表单
      dialogVisiblefeel: false,//申请案例
      imgList:[],//聊天记录
      stageDialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      marketlist: [],
      adviserlist: [],
      sourselist: [],
      edubacklist: url.getEduBack(),
      planList: url.getAbroadYear(), // 赴日时间（与留学计划赴日一致）
      studentTypeList: url.getStudentTypeList(),
      provinceList: [],
      statelist: url.getStateData(),
      japlist: url.getJapLevelList(),
      areaList: [],
      selectedOptions: [],
      showstuid: 0,
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['日语']
      }, //分配表单
      assignSubmiting: false, //分配提交中
      renewDialogVisible: false, // 2026-01升级：续费对话框
      renewForm: {}, // 2026-01升级：续费表单（与日语VIP一致，无默认值）
      renewSubmiting: false,
      followDialogVisible: false,
      followType: '',
      followDialogRow: null,
    };
  },
  components: {
    MingYE,
    OtherDeptFollow,
    FollowDetailDialog,
    AssignResourceDialog,
    SelectAbroad,
    DeptRoleTeacherSelect,
  },
  methods: {
    canEditMingye(row) {
      return user.canEditMingye(row);
    },
    isMarketingOnlyMingye(row) {
      return user.isMarketingOnlyMingye(row);
    },
    isNoAdviserMingye(row) {
      return user.isNoAdviserMingye(row);
    },
    showLimitedOpMingye(row) {
      return user.showLimitedOpMingye(row);
    },
    // 2026-01升级：老学员续费 - 打开续费对话框（与日语VIP一致，无默认值）
    renewClick: function(row) {
      if (!row) return;
      this.renewForm = {
        studentID: row.studentID,
        courseName: '',
        paymentDate: '',
        coursePrice: '',
        amount1: '',
        amount2: '',
        amount3: '',
        phase1Date: '',
        phase2Date: '',
        phase3Date: '',
        percentage: '',
        classHour: '',
        classForm: '',
        startTime: '',
        endTime: ''
      };
      this.renewDialogVisible = true;
    },
    // 2026-01升级：提交续费（与日语VIP一致；接口沿用 renew_payment，缴费金额=一期+二期+三期或全额）
    submitRenew: function() {
      var _this = this;
      _this.$refs.renewFormRef.validate(function(valid) {
        if (!valid) return;
        var sumAmount = (Number(_this.renewForm.amount1) || 0) + (Number(_this.renewForm.amount2) || 0) + (Number(_this.renewForm.amount3) || 0);
        var paymentAmount = sumAmount > 0 ? sumAmount : (Number(_this.renewForm.coursePrice) || 0);
        if (paymentAmount <= 0) {
          _this.$message({ type: 'warning', message: '请填写全额费用或一期/二期/三期金额' });
          return;
        }
        _this.renewSubmiting = true;
        var link = url.getMingye("renew_payment");
        var params = {
          studentID: _this.renewForm.studentID,
          paymentDate: _this.renewForm.paymentDate,
          paymentAmount: paymentAmount,
          coursePrice: Number(_this.renewForm.coursePrice) || 0,
          amount1: Number(_this.renewForm.amount1) || 0,
          amount2: Number(_this.renewForm.amount2) || 0,
          amount3: Number(_this.renewForm.amount3) || 0,
          phase1Date: _this.renewForm.phase1Date || null,
          phase2Date: _this.renewForm.phase2Date || null,
          phase3Date: _this.renewForm.phase3Date || null,
          courseName: (_this.renewForm.courseName || '').trim(),
          classHour: _this.renewForm.classHour != null && _this.renewForm.classHour !== '' ? _this.renewForm.classHour : null,
          classForm: _this.renewForm.classForm || '',
          startTime: _this.renewForm.startTime || null,
          endTime: _this.renewForm.endTime || null
        };
        $.post(link, params, function(res) {
          _this.renewSubmiting = false;
          if (res.status) {
            _this.$message({ type: 'success', message: res.msg || '续费成功' });
            _this.renewDialogVisible = false;
            _this.getList();
          } else {
            _this.$message({ type: 'error', message: res.msg || '续费失败' });
          }
        });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.prop;
      this.query.order = sortColumn.order;
      this.getList();
    },
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 营销/顾问老师：不再按板块获取，直接获取所有启用用户
    getTeacherList: function () {
      var _this = this;
      $.get(url.getStu("getenableusers"), {}, (data) => {
        var list = data || [];
        _this.marketlist = list;
        _this.adviserlist = list;
      });
    },
    getAreaList: function () {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, (data) => {
        _this.areaList = data;
      });
    },
    getProvinceList() {
      var _this = this;
      var link = url.getCommon("getareabyname");
      $.get(link, {}, (data) => {
        _this.provinceList = data || [];
      });
    },
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;
      });
    },
    school: function () {
      var _this = this;
      $.get(url.getCommon("getschool"), {}, function (data) {
        _this.schoollist = data || [];
      });
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getMingye("getlist_vip");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list || [];
        _this.total = data.total || 0;
      });
    },
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    datelClick: function () {
      this.getList();
    },
    adviserClick: function () {
      this.getList();
    },
    // 编辑学生信息（与 Common 一致：列表已带编辑所需字段，直接用 row 回填，不请求接口、不组装对象）
    editStudentClick: function (row) {
      this.studentForm = Object.assign({}, row);
      this.studentForm.id = row.studentID;
      this.selectedOptions = [row.zzProvinceName, row.zzCityName].filter(Boolean);
      ["inputTime", "myInputTime", "paymentDate", "startTime", "endTime"].forEach(function (key) {
        var val = this.studentForm[key];
        if (val && typeof val === "string" && val.length > 10) this.studentForm[key] = val.substring(0, 10);
      }.bind(this));
      if (this.studentForm.abroadDate && typeof this.studentForm.abroadDate === "string" && this.studentForm.abroadDate.length > 7) {
        this.studentForm.abroadDate = this.studentForm.abroadDate.substring(0, 7);
      }
      this.studentDialogVisible = true;
      this.$nextTick(function () {
        if (this.$refs.selectAbroadEdit) this.$refs.selectAbroadEdit.setAbroadTime(this.studentForm.abroadDate);
      });
    },
    // 提交学生信息编辑（同时更新学生表和鸣野表）
    submitStudentForm: function (formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        var info = Object.assign({}, _this.studentForm);
        if (_this.selectedOptions && _this.selectedOptions.length >= 2) {
          info.zzProvinceName = _this.selectedOptions[0];
          info.zzCityName = _this.selectedOptions[1];
        }
        info.recName = _this.studentForm.recName;
        info.myStatus = _this.studentForm.myStatus;
        info.state = _this.studentForm.stateAbroad;
        info.isMingye = true;
        _this.submiting = true;
        var linkStu = url.getStu("AddOrUpdate_Base");
        var infoStu = Object.assign({}, info);
        delete infoStu.applySchool;
        $.post(linkStu, infoStu, (resStu) => {
          if (!resStu.status) {
            _this.submiting = false;
            _this.$message({ type: "error", message: resStu.msg || "学生信息保存失败" });
            return;
          }
          var linkMingye = url.getMingye("addorupdate_base");
          $.post(linkMingye, info, (resMy) => {
            if (!resMy.status) {
              _this.submiting = false;
              _this.$message({ type: "error", message: resMy.msg || "鸣野信息保存失败" });
              return;
            }
            // 若编辑的是某笔缴费行，同步该笔缴费记录的缴费时间
            var paymentID = info.paymentID;
            var paymentDate = info.paymentDate;
            if (paymentID && paymentDate) {
              $.post(url.getMingye("SetPaymentDate"), { paymentID: paymentID, paymentDate: paymentDate }, function (r) {
                _this.submiting = false;
                _this.$message({ type: "success", message: "保存成功" });
                _this.studentDialogVisible = false;
                _this.getList();
              });
            } else {
              _this.submiting = false;
              _this.$message({ type: "success", message: "保存成功" });
              _this.studentDialogVisible = false;
              _this.getList();
            }
          });
        });
      });
    },
    // 课程管理（跳转到课程管理页面）
    openCourseClick: function (row) {
      var url = '/vue/mingyecourse?id=' + row.studentID;
      if (typeof window !== 'undefined' && window.open) {
        window.open(url, '_blank');
      }
    },
    //编辑
    editClickFeel: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisiblefeel = true;
      console.log(this.form);
      
      //聊天图片
      this.imgList = [];
      if(this.form.imgList!=null){
        this.imgList = JSON.parse(this.form.imgList);
      }
    },
    // 2026-01升级：升学操作
    stageClick: function (row) {
      var _this = this;
      var link = url.getMingye("getmodel_base");
      $.get(link, { studentID: row.studentID }, (data) => {
        _this.stageForm = {
          studentID: data.studentID,
          // 赴日前信息
          eduBack: data.eduBack || "",
          schoolName: data.schoolName || "",
          japanese: data.japanese || "",
          english: data.english || "",
          // 升学时信息
          japaneseEnroll: data.japaneseEnroll || "",
          englishEnroll: data.englishEnroll || "",
          examScore: data.examScore || "",
          major: data.major || "",
          artsScience: data.artsScience || "",
          qualifiedTime: data.qualifiedTime || "",
          qualifiedSchools: data.qualifiedSchools || "",
          enrolledSchool: data.enrolledSchool || "",
          enrolledMajor: data.enrolledMajor || "",
        };
        _this.stageDialogVisible = true;
      });
    },
    submitStage: function () {
      var _this = this;
      var link = url.getMingye("update_stage");
      this.submiting = true;
      $.post(link, _this.stageForm, (res) => {
        _this.submiting = false;
        if (res.status) {
          _this.stageDialogVisible = false;
          _this.getList();
          _this.$message({
            type: "success",
            message: res.msg,
          });
        } else {
          _this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    submitForm: function (formName) {
      var _this = this;
      var link = url.getMingye("addorupdate_base");
      var info = this.form;
      info.imgList = JSON.stringify(this.imgList);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.dialogVisiblefeel = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    exportClick: function () {
      var _this = this;
      var params = _this.query;
      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      var link = url.getMingye("exportmingye") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    dialogOpended() {
      var _this = this;
      /**截图上传**/
      if ($("#uploadBtn .uploader_text").length <= 0)
        $("#uploadBtn").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png;jpeg",
          text: "选择图片",
          more: false, //是否可以上传多个
          auto: true, //是否自动上传
          type: "single", //指定处理类型
          max: 1024 * 1024 * 1,
          maxWidth: 2000,
          maxHeight: 2000,
          onSuccess: function (data) {
            //添加到列表,每个图片上传成功都会触发
            console.log(_this.imgList);
            
            _this.imgList.push(data.relativeName);
          },
        });
        if ($('#uploadBtn1 input').length == 0) {
          $('#uploadBtn1').uploader({
            url: url.getUpload(),
            text: '上传文件',
            fileExts: 'pdf;doc;docx',
            handleType: '0',
            onSuccess: function (data) {
              console.info(data)
              var src = url.getDomain() + data.relativeName
              _this.book = data.relativeName
              _this.form.book = data.relativeName
            }
            
          })
        }
        if ($("#uploadBtnConfig input").length == 0) {
        $("#uploadBtnConfig").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png;jpeg",
          handleType: "0",
          maxSize: 1024 * 1024 * 0.5,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "bookPhoto", data.relativeName);
          },
        });
      }
    },
    deleteImg(index){
      console.log(index);
      
      this.imgList.splice(index, 1);
    },
    // 跳转到升学列表
    goToStageList: function() {
      this.$router.push('/mingyestage');
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.studentID != null || row.id != null) ? { ...row, id: row.studentID || row.id } : (row || {});
      this.followDialogVisible = true;
    },
    // 分配（由统一组件 AssignResourceDialog 提交）
    assignClick: function(row) {
      if (!row) return;
      var _this = this;
      var currentUserID = user.getInfo() && (user.getInfo().userID != null ? user.getInfo().userID : user.getInfo().Id);
      _this.assignForm = {
        id: row.studentID || row.id,
        studentID: row.studentID || row.id,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: true,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: _this.userIsAdmain ? (row.jpMarketID || null) : (currentUserID || null),
        myAdviserID: row.myAdviserID || null,
        myMarketID: _this.userIsAdmain ? (row.myMarketID || null) : (currentUserID || null)
      };
      _this.assignDialogVisible = true;
    },
  },
  mounted() {
    this.getAllOrigin();
    this.getTeacherList();
    this.getAreaList();
    this.getProvinceList();
    this.school();
    this.getList();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>


